const JOBS_PREFIX = 'jobs';
const ORDER_PREFIX = 'order';
const ORDER_VIEW_PREFIX = '/orders/:orderGuid';
const JOB_VIEW_PREFIX = '/orders/:orderGuid/jobs/:jobGuid';
const ADMIN_PREFIX = 'admin';
const CONTACTS_PREFIX = 'contacts';
const TERMINAL_PREFIX = 'terminals';
const BULK_IMPORT_PREFIX = 'bulk-import';

export const PATH_NAMES = {
  ROOT: '/',
  accounting: {
    ROOT: '/accounting',
    LIST: '/accounting/:type',
    DETAIL: '/accounting/:type/:guid',
    REPORT: '/accounting/reports/:reportId',
  },
  auth: {
    LOGIN: '/login',
    LOGOUT: '/logout',
    OAUTH_VERIFY: '/oauth/verify',
  },
  jobs: {
    CREATE: `${ORDER_VIEW_PREFIX}/jobs/create`,
    LIST: `/${JOBS_PREFIX}/:status`,
    view: {
      ROOT: JOB_VIEW_PREFIX,
      JOB_DETAILS: JOB_VIEW_PREFIX,
      REQUESTS: `${JOB_VIEW_PREFIX}/requests`,
      ATTACHMENTS: `${JOB_VIEW_PREFIX}/attachments`,
      ACTIVITY: `${JOB_VIEW_PREFIX}/activity`,
      NOTES: `${JOB_VIEW_PREFIX}/notes`,
      LEDGER: `${JOB_VIEW_PREFIX}/ledger`,
    },
  },
  REPORT: `/reports/:reportId`,
  order: {
    CREATE: `/${ORDER_PREFIX}/create`,
    view: {
      ROOT: ORDER_VIEW_PREFIX,
      DETAILS: ORDER_VIEW_PREFIX,
      REQUESTS: `${ORDER_VIEW_PREFIX}/requests`,
      ATTACHMENTS: `${ORDER_VIEW_PREFIX}/attachments`,
      LEDGER: `${ORDER_VIEW_PREFIX}/ledger`,
      NOTES: `${ORDER_VIEW_PREFIX}/notes`,
    },
  },
  terminal: {
    ROOT: `/${TERMINAL_PREFIX}`,
    locations: {
      ROOT: `/${TERMINAL_PREFIX}/locations`,
      CREATE: `/${TERMINAL_PREFIX}/locations/create`,
      VIEW: `/${TERMINAL_PREFIX}/locations/:terminalId`,
      MERGE: `/${TERMINAL_PREFIX}/locations/:terminalId/merge`,
      contacts: {
        ROOT: `/${TERMINAL_PREFIX}/locations/:terminalId/${CONTACTS_PREFIX}`,
        CREATE: `/${TERMINAL_PREFIX}/locations/:terminalId/${CONTACTS_PREFIX}/create`,
        VIEW: `/${TERMINAL_PREFIX}/locations/:terminalId/${CONTACTS_PREFIX}/:contactId`,
        MERGE: `/${TERMINAL_PREFIX}/locations/:terminalId/${CONTACTS_PREFIX}/:contactId/merge`,
      },
    },
    assignments: {
      LIST: `/${TERMINAL_PREFIX}/assignments`,
      CREATE: `/${TERMINAL_PREFIX}/assignments/create`,
      DETAIL: `/${TERMINAL_PREFIX}/assignments/:id`,
    },
    lanes: {
      LIST: `/${TERMINAL_PREFIX}/lanes`,
      CREATE: `/${TERMINAL_PREFIX}/lanes/create`,
      DETAIL: `/${TERMINAL_PREFIX}/lanes/:id`,
    },
  },
  admin: {
    ROOT: `/${ADMIN_PREFIX}`,
    cargoTel: {
      CONFIGS: `/${ADMIN_PREFIX}/cargo-tel/configs`,
    },
    company: {
      ROOT: `/${ADMIN_PREFIX}/app-settings`,
      ROLES: `/${ADMIN_PREFIX}/roles`,
      users: {
        ROOT: `/${ADMIN_PREFIX}/users`,
        VIEW: `/${ADMIN_PREFIX}/users/:userGuid`,
      },
    },
    clients: {
      ROOT: `/${ADMIN_PREFIX}/clients`,
      VIEW: `/${ADMIN_PREFIX}/clients/:clientGuid`,
      contacts: {
        ROOT: `/${ADMIN_PREFIX}/clients/:clientGuid/contacts`,
        VIEW: `/${ADMIN_PREFIX}/clients/:clientGuid/contacts/:contactGuid`,
      },
    },
    vendors: {
      ROOT: `/${ADMIN_PREFIX}/vendors`,
      VIEW: `/${ADMIN_PREFIX}/vendors/:vendorGuid`,
      contacts: {
        ROOT: `/${ADMIN_PREFIX}/vendors/:vendorGuid/contacts`,
        VIEW: `/${ADMIN_PREFIX}/vendors/:vendorGuid/contacts/:contactGuid`,
      },
    },
    orders: {
      ROOT: `/${ADMIN_PREFIX}/${ORDER_PREFIX}/list`,
      REPORT: `/${ADMIN_PREFIX}/${ORDER_PREFIX}/reports/:reportId`,
      CASE_LABELS: `/${ADMIN_PREFIX}/${ORDER_PREFIX}/case-labels`,
    },
    jobs: {
      CASE_LABELS: `/${ADMIN_PREFIX}/${JOBS_PREFIX}/case-labels`,
    },
    lkqFuelRate: {
      ROOT: `/${ADMIN_PREFIX}/lkq-fuel-rate`,
    },
    integrations: {
      CONFIGS: `/${ADMIN_PREFIX}/integrations/configs`,
      COMPANIES: `/${ADMIN_PREFIX}/integrations/companies`,
      APPS: `/${ADMIN_PREFIX}/integrations/apps`,
    },
    loadboards: {
      UNSYNCED: `/${ADMIN_PREFIX}/loadboards/unsynced`,
      DUPLICATES: `/${ADMIN_PREFIX}/loadboards/duplicates`,
    },
    invoices: {
      SYNC_VIN_AMOUNTS: `/${ADMIN_PREFIX}/invoices/sync-vin-amounts`,
    },
  },
  bulkImport: {
    ROOT: `/${BULK_IMPORT_PREFIX}`,
    imports: {
      LIST: `/${BULK_IMPORT_PREFIX}/imports`,
      CREATE: `/${BULK_IMPORT_PREFIX}/imports/create`,
      DETAIL: `/${BULK_IMPORT_PREFIX}/imports/:importGuid`,
    },
    templates: {
      LIST: `/${BULK_IMPORT_PREFIX}/templates`,
      CREATE: `/${BULK_IMPORT_PREFIX}/templates/create`,
      DETAIL: `/${BULK_IMPORT_PREFIX}/templates/:templateId`,
    },
  },
} as const;
